// src/App.jsx
import Home from "./components/Home";
import MenuPage from "./components/MenuPage";
import OrderPage from "./components/OrderPage";
import LoginPage from "./components/LoginPage";
import CheckoutPage from "./components/CheckoutPage";
import Footer from "./components/Footer";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";

function App() {
  return (
    <div className="app-container">
      {/* Navigation */}
      <Navbar />

      {/* Main content must be wrapped in <main> */}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
